
import { CreateAddress } from './googlePlace.model';

export class FetchGooglePlace {
    static readonly type = '[GooglePlace] Fetch GooglePlace';
    constructor(public search: string) { }
}
